import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {SaisineStatus} from './saisine.model';
import {Saisineline} from './saisineline.model';

import 'rxjs/add/operator/map';


@Injectable()
export class SaisineLineService {
    private resourceInterneUrl = 'api/interne/saisines';
    constructor(private http: Http) { }

    query(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceInterneUrl, options).map((res: any) => this.convertResponse(res));
    }
    count(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        let params: URLSearchParams = new URLSearchParams();
        params.set('campaign', req.campaign);
        options.search = params;
        return this.http.get(this.resourceInterneUrl + '/count', options);
    }

    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i] = this.fromJSON(jsonResponse[i]);
        }
        res._body = jsonResponse;
        return res;
    }
    // bind to this
    fromJSON = (pJson: Response | any): Saisineline => {
        let json = null;
        if (pJson instanceof  Response) {
            json = (pJson as Response).json();
        } else {
            // Regular JSON
            json = pJson;
        }
        let saisine: Saisineline = Object.assign(new Saisineline(), json);
        if (saisine.status == null) {
            saisine.status = SaisineStatus.IN_PROGRESS;
        } else {
            saisine.status = SaisineStatus[saisine.status + ''];
        }
        return saisine;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('campaign', req.campaign);
            params.set('query', req.query);
            if (req.filters && req.filters.reference && req.filters.reference.value) {
                params.set('reference', req.filters.reference.value);
            }
            if (req.filters && req.filters.studentName && req.filters.studentName.value) {
                params.set('studentName', req.filters.studentName.value);
            }
            if (req.filters && req.filters.licenceTitle && req.filters.licenceTitle.value) {
                params.set('licenceTitle', req.filters.licenceTitle.value);
            }
            if (req.filters && req.filters.licenceSchoolLabel && req.filters.licenceSchoolLabel.value) {
                params.set('licenceSchoolLabel', req.filters.licenceSchoolLabel.value);
            }
            if (req.filters && req.filters.status && req.filters.status.value) {
                params.set('status', req.filters.status.value.map(v => SaisineStatus[v]));
            }
            if (req.filters && req.filters.numberAdmissionRequest && req.filters.numberAdmissionRequest.value) {
                params.set('numberAdmissionRequest', req.filters.numberAdmissionRequest.value);
            }
            if (req.filters && req.filters.numberStudentProposals && req.filters.numberStudentProposals.value) {
                params.set('numberStudentProposals', req.filters.numberStudentProposals.value);
            }
            if (req.filters && req.filters.numberStudentRefused && req.filters.numberStudentRefused.value) {
                params.set('numberStudentRefused', req.filters.numberStudentRefused.value);
            }
            if (req.filters && req.filters.numberStudentConfirmed && req.filters.numberStudentConfirmed.value) {
                params.set('numberStudentConfirmed', req.filters.numberStudentConfirmed.value);
            }
            if (req.filters && req.filters.licenceAcademyLabel && req.filters.licenceAcademyLabel.value) {
                params.set('licenceAcademyLabel', req.filters.licenceAcademyLabel.value);
            }
            if (req.filters && req.filters.licenceAcademicRegionLabel && req.filters.licenceAcademicRegionLabel.value) {
                params.set('licenceAcademicRegionLabel', req.filters.licenceAcademicRegionLabel.value);
            }
            if (req.filters && req.filters.licenceAcademicRegionLabel && req.filters.licenceAcademicRegionLabel.value) {
                params.set('licenceAcademicRegionLabel', req.filters.licenceAcademicRegionLabel.value);
            }
            if (req.filters && req.filters.hasDisability && req.filters.hasDisability.value !== undefined) {
                params.set('hasDisability', req.filters.hasDisability.value);
            }
            if (req.first) {
                params.set('_first', req.first);
            }
            if (req.rows) {
                params.set('_rows', req.rows);
            }
            if (req.multiSortMeta) {
                params.set('_sort', req.multiSortMeta.map(sort => sort.field + (sort.field === 'hasDisability' ? sort.order === 1 ? ' desc' : ' asc' : sort.order === 1 ? ' asc' : ' desc')).join(','));
            }
            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisineline.service.ts